package com.macrofocus.eflux.network.physical

import com.macrofocus.eflux.data.BusPowerFlowRecord
import com.macrofocus.eflux.network.toFixed

data class Bus(val record: BusPowerFlowRecord, val zone: Zone?, val longName: String = record.name) {
    val v = record.baskv * record.vm.amount

    val dropLast = record.name.takeLast(3).dropLast(1)
    val type: String = if (dropLast == "_P") {
        if (record.name.last().isDigit()) {
            "Branch"
        } else {
            "Unknown"
        }
    } else {
        if (record.name.last().isDigit()) {
            "Busbar"
        } else {
            "LoadGen"
        }
    }

    private val name by record::name

    val fullName = record.baskv.amount.toFixed(0) + " " + record.baskv.unit + " " + longName

    val id = busIdOf(name)

    fun left6() = name.left6()

    fun left7() = name.left7()

    override fun toString(): String = id
}

fun Char.isDigit(): Boolean {
    return this >= '0' && this <= '9'
}

fun Char.isLetter(): Boolean {
    return (this >= 'a' && this <= 'z') || (this >= 'A' && this <= 'Z')
}
